import React from 'react';
import '../practice-view.scss';
import TitleBar from 'components/PracticeView/TitleBar/TitleBar.react';
import QuestionsListHeader from 'components/PracticeView/QuestionsListHeader/QuestionsListHeader.react';
import {ListGroup, ListGroupItem, Text} from '@albert-io/atomic';

import {EmptyQuestionShell} from '../EmptyQuestionShell/EmptyQuestionShell.react';

interface EmptyPracticeViewProps {
  questionListHeader: string;
  noQuestionSetsMessage: string;
  titleBarTitle: string;
  titleBarBackButton: React.ReactNode;
  toolbar?: React.ReactNode;
}

/**
 * @param props
 * @returns {React.ReactNode}
 *
 * An easy to use component for rendering practice views without question lists.
 * Designed to be agnostic of practice view type. All logic is static, but there is an option
 * to pass a practice view toolbar if needed.
 */

const EmptyPracticeView = ({
  questionListHeader,
  noQuestionSetsMessage,
  titleBarTitle,
  titleBarBackButton,
  toolbar
}: EmptyPracticeViewProps) => {
  return (
    <div className='practice-view u-display_flex u-flex-direction_column u-overflow_auto'>
      <div className='practice-view__title-bar'>
        <TitleBar title={titleBarTitle} backButton={titleBarBackButton} />
        {toolbar}
      </div>
      <div className='practice-view__main-wrapper u-display_flex u-justify-content_center u-flex-grow_1 u-overflow_hidden u-bgc_slate-100'>
        <div className='practice-view__main u-display_flex u-flex-grow_1 u-overflow_hidden'>
          <div className='practice-view__questions-wrapper u-display_flex u-overflow_hidden u-pad-b_2 u-pad-r_2 u-pad-t_2'>
            <ListGroup className='u-display_flex u-flex-direction_column'>
              {/* <ListGroupItem header>{questionListHeader}</ListGroupItem> */}
              <ListGroupItem header>
                <QuestionsListHeader heading={questionListHeader} selectedQuestionCount={0} />
              </ListGroupItem>
              <div className='u-pad-tb_4 u-pad-lr_6 u-text-align_center'>
                <Text as='p' size='l' emphasis='low'>
                  {noQuestionSetsMessage}
                </Text>
              </div>
            </ListGroup>
          </div>
          <div className='practice-view__question-area u-flex-grow_1 u-overflow_auto'>
            <div className='practice-view__question-area u-flex-grow_1'>
              <EmptyQuestionShell />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EmptyPracticeView;
